
import { defineComponent } from 'vue';
import useCapabilities from '@/resources/capabilities';
import api from '@/api';
import withTimeout from '@/resources/timeOut';
// eslint-disable-next-line import/no-cycle
import { filtersToQueryParameters, setQueryParameters } from '@/helpers/Url';
import VTable from '@/components/vendor/basic/table/VTable.vue';
import VTableHeader from '@/components/vendor/basic/table/VTableHeader.vue';
import VTableBody from '@/components/vendor/basic/table/VTableBody.vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VInput from '@/components/vendor/basic/form/parts/VInput.vue';
import Professional from '@/api/objects/Professional';
import TheAdminProfessionalShow
  from '@/views/administrator/professional/parts/TheAdminProfessionalShow.vue';
import TheAdminProfessionalUpdate
  from '@/views/administrator/professional/parts/TheAdminProfessionalUpdate.vue';
import TheAdminProfessionalDestroy
  from '@/views/administrator/professional/parts/TheAdminProfessionalDestroy.vue';
import VPagination from '@/components/vendor/VPagination.vue';

export default defineComponent({
  name: 'TheAdminProfessionalsList',
  components: {
    VPagination,
    TheAdminProfessionalDestroy,
    TheAdminProfessionalUpdate,
    TheAdminProfessionalShow,
    VInput,
    VButton,
    VTableBody,
    VTableHeader,
    VTable,
  },
  data() {
    return {
      professionals: [] as Professional[],
      pagination: null as any,
      selectedProfessional: null as null | Professional,
      modalToShow: null as null | string,
      filters: {
        search: [] as any,
      },
      do_search: true,
      timers: {
        search: '',
      },
    };
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  async mounted() {
    await this.setQueryParametersAsFilters();
    await this.doSearch();
  },
  methods: {
    openProfessionalModal(professional, modalName) {
      this.selectedProfessional = professional;
      this.modalToShow = modalName;
    },
    search() {
      this.timers.search = withTimeout(async () => {
        await this.doSearch();
      }, this.timers.search, 250);
    },
    /**
     * Sets the local filters as url query parameters.
     */
    setFiltersAsQueryParameters() {
      setQueryParameters('admin.professional.index', this.filters);
    },
    /**
     * Detects any query parameter in the url and loads it in the filters (if available)
     *
     * @returns {Promise<void>}
     */
    async setQueryParametersAsFilters() {
      const queryParameters = this.$route.query;

      if (queryParameters.search) {
        this.filters.search = queryParameters.search;
      } else {
        this.filters.search = '';
      }
    },
    async loadProfessionals(page?: number) {
      try {
        const filters = { ...this.filters } as any;

        // We manage page filter if provided
        if (!!page) {
          filters.page = page;
        }

        const query = filtersToQueryParameters(filters);

        const resp = await api.admin.professional.all(query, true);

        if (!!resp.meta) {
          this.professionals = resp.data;

          this.pagination = {
            meta: resp.meta,
            pagination: resp.links,
          };
        } else {
          this.professionals = resp;
        }
      } catch (e) {
        this.$toast.error(this.$t('Ha ocurrido un error al cargar los profesionales'));
      }
    },
    async doSearch() {
      this.do_search = false;
      await this.setFiltersAsQueryParameters();
      await this.loadProfessionals();
    },
    async handlePageChangedEvent(page) {
      // We handle page only on the method call to avoid malfunctioning with page filter
      await this.loadProfessionals(page);
    },
    emptyFilters() {
      this.filters = {
        search: '',
      };

      this.doSearch();
    },
  },
});
